<template>
	<div class="serve-root">
		<Form @submit="onSubmit">
			<Panel style="margin-bottom:10px;" title="车型信息">
				<Field v-model="carModal" name="car_model" label="车型" placeholder="请输入车型" :rules="[{ required: true, message: '请填写车型' }]" />
				<Field v-model="carNumer" name="car_number" label="车牌号" placeholder="请输入车牌号" :rules="[{ required: true, message: '请填写车牌号' }]" />
				<Field readonly clickable name="service_package" :value="severPackage" label="选择服务" placeholder="点击选择服务类型" @click="showUser = false" />
			</Panel>
			<Panel style="margin-bottom:10px;" title="联系方式">
				<div>
					<Field v-model="name" name="name" label="姓名" placeholder="请输入姓名" :rules="[{ required: true, message: '请填写姓名' }]" />
					<Field v-model="mobile" name="mobile" label="手机号" type="tel" placeholder="请输入手机号" :rules="[{ required: true, message: '请填写联系方式' }]" />
				</div>
			</Panel>
			<Panel style="margin-bottom:10px;" title="地址信息">
				<div>
					<Field v-model="reserveAddress" name="reserve_address" label="地址" placeholder="请输入地址" type="textarea" :rules="[{ required: true, message: '请填写地址' }]" />
				</div>
			</Panel>
			<Panel style="margin-bottom:10px;" title="预约时间">
				<Field readonly clickable name="calendar" :value="value" label="日期选择" placeholder="点击选择日期" @click="showCalendar = true" :rules="[{ required: true, message: '请选择日期' }]"/>
				<Field readonly clickable name="datetimePicker" :value="tiemValue" label="时间选择" placeholder="点击选择时间" @click="showPicker = true" :rules="[{ required: true, message: '请选择时间' }]"/>
				<Popup v-model="showPicker" position="bottom">
					<DatetimePicker type="time" :filter="filter" @confirm="onConfirmTime" @cancel="showPicker = false" />
				</Popup>
			</Panel>
			<div class="read-wrap">
				<Checkbox v-model="checked" shape="square" icon-size="20px">我已阅读</Checkbox>
				<span class="link" @click="showRead = true">《24h车服务上门养车预约须知》</span>
			</div>
			<div style="margin: 16px;">
				<Button round block type="info" native-type="submit">
					马上预约
				</Button>
			</div>
		</Form>
		<Calendar v-model="showCalendar" color='linear-gradient(to right, #4bb0ff, #6149f6)' @confirm="onConfirm" />
		<van-dialog v-model="showUser" @confirm="confirmPhoneHandle" title="请选择服务项目" show-cancel-button>
			<div class="list-wrap">
			</div>
		</van-dialog>
		<div class="footer">点击“马上预约”后，车管家将根据您的车型给您精准报价，请您保持电话畅通。</div>
		<Popup v-model="showRead" class="rules">
			<div>
				<h2 style="padding-bottom: 1em;">车服务上门养车预约须知</h2>
				<p>亲爱的用户：</p>
				<p style="text-indent: 2em;">您好！非常欢迎您选择<strong>24h车服务</strong>上门养车。为使您得到更优质满意的服务，以下事项敬请关注。给您带来的不便，敬请谅解。 </p>
				<p>1、您可以在我们的微信公众号预约订单或者致电 0477-5100212，电话预约。 </p>
				<p>2、当日预约只能预约次日及以后的上门服务，预约时段为周一至周日10：00-16：00。如遇国家法定节假日，可预约服务的时间以易快修官方通知为准。 </p>
				<p>3、预约后车管家与您电话沟通具体服务价格、所用配件等。 </p>
				<p>4、确认订单后，为了让您的服务得到保障，可以服务后根据约定价格付款。</p>
				<p>5、服务区域为维修门店所在地的大部分区域。 </p>
				<p>6、上门服务时，请尽量选择较为空旷的停车环境，车身周围1米范围内无障碍物为佳。 </p>
				<p>7、如果技师经过保养检查后，产生需要到店服务的项目，请致电 0477-5100212，我们会为您推荐附近门店进行服务。 </p>
				<p>8、如需更改服务时间或取消订单，请于指定时间致电 0477-5100212 进行相关操作。指定时间指：若所预约服务时间段为10：00-12：00，于前一天工作时间（9：00-18：00）内致电。若所预约服务时间为13：00-16：00，请于服务时间开始的2小时之前致电。在此之间更改服务时间或取消订单，不收取任何费用。 </p>
				<p>9、服务开始前两小时内不得更改服务时间。如果在服务开始前两小时之内取消订单，需扣除100元空单费。如果超过服务开始时间30分钟仍未到达预定地点进行服务，视为取消订单，按照扣除100元空单费。 </p>
				<p>10、24h车服务上门养车技师只负责上门服务的相关工作，并解答相关车辆养护、维修等问题。如有其他疑问，请及时联系我们，我们会在第一时间解答您的疑问、解决您的问题。 </p>
				<p>11、如果在服务过程中您有任何的不满意，请您拨打客服电话 0477-5100212 及时反馈我们，我们一定会妥善解决，您的满意就是我们的最大心愿。 </p>
				<p style="font-weight:bold; font-size: larger;">祝您生活愉快！</p>
			</div>
		</Popup>
	</div>
</template>

<script>
	import {
		api,
		http
	} from 'utils/'
	import {
		Dialog,
		Toast
	} from 'vant';
	export default {
		data() {
			return {
				showCalendar: false,
				showPicker: false,
				showRead: false,
				checked: false,
				showUser: false,
				name: "",
				mobile: "",
				reserveAddress: "",
				severPackage: "",
				carNumer: "",
				value: "",
				tiemValue: "",
				carModal: ""
			}
		},
		components: {
			[Dialog.Component.name]: Dialog.Component
		},
		created() {
			let {
				query: {
					service_id,
					service_name
				}
			} = this.$route
			document.title = '上门服务'
			this.severPackage = service_name
			this.severPackageId = service_id
		},
		watch: {
			$route(value) {
				let {
					meta: {
						name
					}
				} = value
				document.title = name
			}
		},
		methods: {
			toggle(index) {
				this.$refs.checkboxes[index].toggle();
			},
			async queryOilList() {
				const res = await http({
					url: api.oilList
				})
				if (res) {
					this.oilList = res
				}
			},
			async queryPackageList() {
				const res = await http({
					url: api.packageList
				})
				if (res) {
					this.packageList = res
				}
			},
			async postHandle(data) {
				const res = await http({
					url: api.servePost,
					method: 'POST',
					data: {
						...data,
						reserve_type: 1
					}
				})
				console.log(res)
				if (res) {
					this.$router.push('/success')
				}
			},
			filter(type, options) {
				if (type === 'hour') {
					return options.filter(option => {
						if (parseInt(option) > 7 && parseInt(option) < 20) {
							return option
						}
					});
				}
				if (type === 'minute') {
					return options.filter(option => option % 30 === 0);
				}
				return options;
			},
			onSubmit(values) {
				if (this.checked) {
					let reserve_time = `${values.calendar} ${values.datetimePicker}`
					delete values['calendar']
					delete values['datetimePicker']
					let option = {
						...values,
						reserve_time,
						service_package: parseInt(this.severPackageId)
					}
					this.postHandle(option)
				} else {
					Toast('请选择我已阅读');
				}
			},
			confirmPhoneHandle() {
				console.log('确认')
			},
			onConfirm(date) {
				this.value = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
				this.showCalendar = false;
			},
			onConfirmTime(time) {
				this.tiemValue = time;
				this.showPicker = false;
			},
		}
	}
</script>

<style lang="less">
	.serve-root {
		width: 100%;
		height: 100%;
		overflow: auto;
		padding: 20px 12px;

		.van-cell__title {
			text-align: left;
		}

		.van-collapse-item__content {
			padding: 0;
		}

		.read-wrap {
			padding: 12px 12px 0 12px;
			display: flex;

			.link {
				color: #1989fa;
			}
		}
		
		.rules {
			width: 80%;
			height: 90%;
			padding: 20px;
		}

		.footer {
			text-align: center;
			padding: 0 50px;
			font-size: 12px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: rgba(153, 153, 153, 1);
			line-height: 17px;
		}

		.list-wrap {
			padding: 12px;
			height: 300px;
			overflow: auto;
		}
	}
</style>
